import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SubscriptionBadgeComponent } from './components/subscription-badge/subscription-badge.component';
import { CopyValueComponent } from './components/copy-value/copy-value.component';
import { AuditStatusBadgeComponent } from './components/audit-status-badge/audit-status-badge.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { ConfirmDeleteOrgDialogComponent } from './components/confirm-delete-org-dialog/confirm-delete-org-dialog.component';
import { ConfirmActionDialogComponent } from './components/confirm-action-dialog/confirm-action-dialog.component';
import { CreateTemplateDialogComponent } from '../pages/template-catalog/create-template-dialog.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { TrialBadgeComponent } from './components/trial-badge/trial-badge.component';
import { ContentChangedComponent } from './components/content-changed/content-changed.component';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatCardModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatChipsModule,
  MatTooltipModule,
  MatDialogModule,
  MatSnackBarModule,
  MatMenuModule,
  MatBadgeModule,
  MatSelectModule,
  MatDividerModule,
  MatSlideToggleModule,
  MatListModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatAutocompleteModule,
  MatRadioModule,
];

@NgModule({
  declarations: [SubscriptionBadgeComponent, TrialBadgeComponent, CopyValueComponent, AuditStatusBadgeComponent, ContentChangedComponent, LoaderComponent, ConfirmDeleteOrgDialogComponent, ConfirmActionDialogComponent, CreateTemplateDialogComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    ...MATERIAL_MODULES,
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SubscriptionBadgeComponent,
    TrialBadgeComponent,
    CopyValueComponent,
    AuditStatusBadgeComponent,
    ContentChangedComponent,
    LoaderComponent,
    ConfirmDeleteOrgDialogComponent,
    ConfirmActionDialogComponent,
    CreateTemplateDialogComponent,
    ...MATERIAL_MODULES,
  ],
})
export class SharedModule {}
